import React from 'react';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import PropTypes from 'prop-types';
import OptimizedImage from '../OptimizedImage';

const PartialsQuestion = ({ title, subtitle, additionalConfig }) => {
  return (
    <div className="have-question">
      <div className="have-question__bg-container">
        <OptimizedImage src="haveaquestion_image.png" className="content" />
      </div>
      <div className="container">
        <div className="content">
          <div className="body">
            <h2 className="tt">{title}</h2>
            <div className="dd">
              {(additionalConfig && additionalConfig.subtitle) || subtitle}
            </div>
            <AniLink
              cover
              bg="#EAEBF1"
              to="/contact/"
              className="btn btn-main narrow fill"
            >
              {(additionalConfig && additionalConfig.btnText) || 'Contact us'}
            </AniLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartialsQuestion;

PartialsQuestion.defaultProps = {
  title: 'Tell us about your project',
  subtitle: 'Get in touch and let’s build your project!',
  additionalConfig: PropTypes.object
};
